import { useSelector } from 'react-redux';

const useAnnouncementContainer = () => useSelector(({
  layout: { fullscreen },
  notifications: { announcements: { all: { readStatus, open, hideForSession } } },
  themes: { theme },
}) => ({
  fullscreen,
  hideForSession,
  readStatus,
  showAnnouncements: open,
  theme,
}));

const useAnnouncementContent = () => useSelector(({
  notifications: { announcements: { all: { results, count, currentIndex: index } } },
}) => {
  const {
    headline, dateTimeFrom, dateTimeTo, linkedContent, messageStatus: level,
  } = results[index];

  return {
    count,
    dateTimeFrom,
    dateTimeTo,
    headline,
    index,
    level,
    linkedContent,
  };
});

const useAnnouncementNav = () => {
  const { count, currentIndex: index } = useSelector(
    ({ notifications: { announcements: { all } } }) => all,
  );
  return { count, index };
};

export default {
  useAnnouncementContainer,
  useAnnouncementContent,
  useAnnouncementNav,
};
